var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .geo-cls-1 {\n        fill: #d0d6dc;\n      }\n\n      .geo-cls-2 {\n        fill: none;\n        opacity: .2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_2-2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "geo-cls-2",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M12,22c1.12,0,2.34-2.46,2.88-6.32h-5.75c.53,3.87,1.75,6.32,2.88,6.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M12,1c-1.12,0-2.33,2.42-2.87,6.24h5.73c-.54-3.82-1.75-6.24-2.87-6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M19.14,7.24c-.95-2.86-2.82-5.03-5.1-5.86.88,1.32,1.49,3.46,1.82,5.86h3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M4.86,7.24h3.27c.33-2.4.95-4.54,1.83-5.86-2.28.83-4.15,3.01-5.1,5.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M20.18,7.24h1.96c-1.15-2.73-3.38-4.9-6.15-5.98,1.89,1.26,3.39,3.39,4.18,5.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M20.81,11.5c0,1.1-.13,2.17-.35,3.18h2.06c.3-1.01.47-2.07.47-3.18s-.17-2.23-.49-3.26h-2.06c.24,1.03.37,2.13.37,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M15.15,11.5c0-1.16-.06-2.25-.16-3.26h-5.97c-.1,1.01-.16,2.1-.16,3.26s.06,2.19.16,3.18h5.99c.1-.99.16-2.05.16-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M1.49,8.24c-.32,1.03-.49,2.13-.49,3.26s.17,2.17.47,3.18h2.06c-.22-1.01-.35-2.07-.35-3.18s.13-2.23.37-3.26H1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M3.82,7.24c.8-2.59,2.29-4.72,4.18-5.98-2.77,1.08-5,3.24-6.15,5.98h1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M3.8,15.68h-1.97c1.14,2.77,3.38,4.97,6.18,6.06-1.91-1.28-3.42-3.43-4.21-6.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M4.19,11.5c0,1.11.13,2.17.37,3.18h3.45c-.1-1.04-.16-2.12-.16-3.18s.06-2.19.17-3.26h-3.44c-.25,1.03-.39,2.12-.39,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M20.2,15.68c-.79,2.63-2.3,4.79-4.21,6.06,2.8-1.09,5.04-3.29,6.18-6.06h-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M19.81,11.5c0-1.14-.14-2.23-.39-3.26h-3.44c.11,1.07.17,2.17.17,3.26s-.05,2.13-.16,3.18h3.45c.24-1,.37-2.07.37-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M9.96,21.63c-.89-1.34-1.51-3.51-1.84-5.95h-3.29c.94,2.9,2.82,5.11,5.13,5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "geo-cls-1",
    d: "M19.17,15.68h-3.29c-.33,2.44-.95,4.61-1.84,5.95,2.3-.84,4.19-3.05,5.13-5.95Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.958131d295c1f59069cc4c35483eb64a.svg";
export { ForwardRef as ReactComponent };